import { Stack, TextField, IconButton } from "@mui/material"
import { Fragment} from "react";
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

export const AddContactForm = ({formValues, handleInputChange }) => {

    const {contacts} =formValues;
    const jsonContacts = (typeof contacts === 'string') ? JSON.parse(contacts) : contacts;

    const handleChangeInput = (id, event) => {
        const newInputFields = jsonContacts.map(i => {
            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })
        handleInputChange({ 'target': { 'name': 'contacts', 'value': newInputFields } })
    }

    const handleAddFields = () => {
        handleInputChange({ 'target': { 'name': 'contacts', 'value':[...jsonContacts, { id: uuidv4(), contactName: '', jobPosition: '', contactTel: '', contactEmail: '' }]}})
    }

    const handleRemoveFields = id => {
        const values = [...jsonContacts];
        values.splice(values.findIndex(value => value.id === id), 1);
        handleInputChange({ 'target': { 'name': 'contacts', 'value': values } })
    }

    return (
        <Fragment>
            <Stack>
                {jsonContacts.map(inputField => (
                    <Stack width='100%' alignItems='center' key={inputField.id} flexDirection='row' justifyContent='space-between'>
                        <TextField
                            sx={{ width: '27%' }}
                            label="Contacto"
                            type="search"
                            variant="standard"
                            fullWidth
                            name="contactName"
                            value={inputField.contactName}
                            onChange={event => handleChangeInput(inputField.id, event)}
                        />
                        <TextField
                            sx={{ width: '22%' }}
                            label="Cargo"
                            type="search"
                            variant="standard"
                            fullWidth
                            name="jobPosition"
                            value={inputField.jobPosition}
                            onChange={event => handleChangeInput(inputField.id, event)}
                        />

                        <TextField
                            sx={{ width: '15%' }}
                            label="Teléfono"
                            type="search"
                            variant="standard"
                            fullWidth
                            name="contactTel"
                            value={inputField.contactTel}
                            onChange={event => handleChangeInput(inputField.id, event)}
                        />
                        <TextField
                            sx={{ width: '25%' }}
                            label="Email"
                            type="email"
                            variant="standard"
                            fullWidth
                            name="contactEmail"
                            value={inputField.contactEmail}
                            onChange={event => handleChangeInput(inputField.id, event)}
                        />
                        <IconButton disabled={contacts.length === 1} onClick={() => handleRemoveFields(inputField.id)}>
                            <DeleteIcon color='primary' />
                        </IconButton>
                        <IconButton
                            onClick={handleAddFields}
                        >
                            <AddIcon />
                        </IconButton>
                    </Stack>
                ))}
            </Stack>
        </Fragment>
    )
}